import { render, staticRenderFns } from "./ProLinksBox.vue?vue&type=template&id=5aec8e76&scoped=true&"
import script from "./ProLinksBox.vue?vue&type=script&lang=js&"
export * from "./ProLinksBox.vue?vue&type=script&lang=js&"
import style0 from "./ProLinksBox.vue?vue&type=style&index=0&id=5aec8e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aec8e76",
  null
  
)

export default component.exports